import packageJson from '../../../package.json';

const VersionTag = () => {
    return (
        <div className="bg-amber-300 font-semibold p-2">
            <span>v-{packageJson.version}</span>
        </div>
    )
}

export default VersionTag;
